import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import tagsActions from '../../store/tags/action-creators';
import TagForm from './TagForm';

class TagEdit extends Component {
  constructor(props) {
    super(props);
    this.saveTag = this.saveTag.bind(this);
  }

  // ----------------------
  // Methods
  // ----------------------

  saveTag(properties) {
    this.props.updateTag({
      ...properties,
      tagGuid: this.props.tag.guid,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.tag && (
          <TagForm
            initialValues={this.props.tag}
            isLoading={this.props.isLoading}
            onSave={this.saveTag}
          />
        )}
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.tags.isLoading.includes('updateTag'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateTag: formData => dispatch(tagsActions.updateTag(formData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagEdit);
